// Valor por defecto de site.
export const defaultSite = () => {
    return {
        id: null,
        name: null,
        description: null,
    };
};

// Valores por defecto de filterSites.
export const defaultFilterSites = () => {
    return {
        search: null,
        page: 1,
        total: 0,
        per_page: 10,
    };
};

// Valores por defecto de sites.
export const defaultSites = () => {
    return [];
}

// Valores por defecto de sitesActive.
export const defaultSitesActive = () => {
    return [];
}

export default {
    site: defaultSite(),
    filterSites: defaultFilterSites(),
    sites: defaultSites(),
    sitesActive: defaultSitesActive(),
};
